<template>
  <div>
<!--    <div class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">-->
<!--      <div class="max-w-md w-full space-y-8">-->
<!--        <div>-->
<!--          <img class="mx-auto h-12 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg" alt="Workflow" />-->
<!--          <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">EMHUB教育平台</h2>-->
<!--        </div>-->
<!--        <form class="mt-8 space-y-6" action="#" method="POST">-->
<!--          <input type="hidden" name="remember" value="true" />-->
<!--          <div class="rounded-md shadow-sm -space-y-px">-->
<!--            <div>-->
<!--              <label for="username" class="sr-only">用户名</label>-->
<!--              <input id="username" name="username" type="input" autocomplete="username" required="" class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="用户名" />-->
<!--            </div>-->
<!--            <div>-->
<!--              <label for="password" class="sr-only">密码</label>-->
<!--              <input id="password" name="password" type="password" autocomplete="current-password" required="" class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="密码" />-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="flex items-center justify-between">-->
<!--            <div class="flex items-center">-->
<!--              <input id="remember-me" name="remember-me" type="checkbox" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" />-->
<!--              <label for="remember-me" class="ml-2 block text-sm text-gray-900"> 记住我 </label>-->
<!--            </div>-->

<!--            <div class="text-sm">-->
<!--              <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500"> 忘记密码 </a>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div>-->
<!--            <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">-->
<!--              登录-->
<!--            </button>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
  </div>

</template>

<script>
export default {
  name: "test",
  data(){
    return {

    }
  },
}
</script>

<style scoped>

</style>